import React, { useEffect, useState } from "react";
import DeactiveClubModal from "./modals/DeactiveClubModal";
import axios from "axios";
import { useAuthContext } from "../../hooks/useAuthContext";
import { ApiConnectionString } from "../../constants/ApiConntection";
import LoadingSpinner from "../../components/LoadingSpinner";
import { loadStripe } from "@stripe/stripe-js";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import { StripeApiKeyString } from "../../constants/StripeApiKey";

export default function Settings({id}) {

  
  const [deactiveClubModal, setDeactiveClubModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuthContext();
  const [club,setClub] = useState(null)

  //stripe checkout

  const stripePromise = loadStripe(StripeApiKeyString);
  const [checkout, setCheckout] = useState(false);
  const [clientSecret, setClientSecret] = useState(null);
  const [checkoutComplete, setCheckoutComplete] = useState(false);

  const dashboardAccess = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${ApiConnectionString}/api/dashboard`, {
        headers: { Authorization: `Bearer ${user.token}` },
      });
  
      if (response.status === 200) {
        window.location.href = response.data; // Redirect to the URL in response.data
      }
    } catch (error) {
      console.error("Error fetching dashboard:", error);
    } finally {
      setIsLoading(false);
    }
  };


  const handleCompleteCheckout = () => {
    setCheckoutComplete(true);
  };

  const options = {
    clientSecret,
    onComplete: handleCompleteCheckout,
  };
  const checkoutfunc = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        `${ApiConnectionString}/api/PlatformCheckout/NewSubscription/${id}`,
        null,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (response.status === 200) {
        setClientSecret(response.data); // Fixed incorrect variable name (premResponse → response)
        setCheckout(true);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const customerPortal = async () => {
    try {
      setIsLoading(true);

      const billingPortalResponse = await axios.get(
        `${ApiConnectionString}/api/PlatformBillingPortal/${id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (billingPortalResponse.status === 200) {
        window.location.href = billingPortalResponse.data;
      }
    } catch (error) {
      console.error("Failed to open billing portal:", error);
    } finally {
      setIsLoading(false);
    }
  };

const fetchData = async () => {
  setIsLoading(true);
  try {
    const clubResponse = await axios.get(
      `${ApiConnectionString}/api/myclub/${id}`,
      {
        headers: { Authorization: `Bearer ${user.token}` },
      }
    );
    setClub(clubResponse.data)
    // handle clubResponse if needed
  } catch (error) {
    console.error("Error fetching club data:", error);
    // optionally set error state here
  } finally {
    setIsLoading(false);
  }
};

useEffect(() => {
fetchData()
},[])

  const cancelModal = () => {
    setDeactiveClubModal(false);
  };


  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  } else if (club) {
    return (
      <div className="container">
        <div className="lightBlueBanner">
          <p className="fw-bold p-2">Settings</p>
        </div>

        <p>You can access your express account to view transactions and payouts.</p>
    <button onClick={dashboardAccess} className="saveChanges-button ">
      Go to Stripe Dashboard
    </button>

        <hr></hr>
        {club.premiumFreeTrial && (
          <p>
            This club is on a free trial until{" "}
            {new Date(club.premiumFreeTrial).toLocaleDateString()}.
          </p>
        )}
        {club.premium && !club.premiumCancelPending && (
          <p>This club has an active subscription. </p>
        )}

        {club.premium && club.premiumCancelPending && (
          <p className="text-danger">
            This club has an active subscription but has been canceled. It will
            remain active until the end of the current billing period.
          </p>
        )}

        {!club.premium && club.premiumFreeTrial == null && (
          <div>
      {!checkout &&   <div>   <p>
              This club is no longer active. Please renew the subscription via
              Stripe Connect using the button below.
            
            </p>  <button onClick={checkoutfunc} className="saveChanges-button mb-4">
                Renew Subscription
              </button> </div>}

            {checkout && (
          <div id="checkout" className="mt-5 container">
            <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
              <EmbeddedCheckout />
            </EmbeddedCheckoutProvider>
            {checkoutComplete && (
              <div>
              {checkoutComplete  && <p className="text-success">
                  Subscription successfully created. Please allow a few moments
                  for this to update in our system.
                </p>}
              </div>
            )}
          </div>
        )}
          </div>
        )}


  


        <button className="saveChanges-button" onClick={customerPortal}>
          Manage Billing
        </button>

        <hr></hr>
        <p>
          If you wish to deactivate this club, you can do so by pressing the
          deactivate button below.
        </p>

        <button
          className="delete-button my-3"
          onClick={() => setDeactiveClubModal(true)}
        >
          Deactive Club
        </button>

    
        <hr></hr>
        {deactiveClubModal && (
          <DeactiveClubModal cancelModal={cancelModal} club={club} />
        )}
      </div>
    );
  }
}
